export const themeData3 = {
  showRating: true,
  ratingBg: '#DE9356',
  showBtn: true,
  btnTextColor: '#fff',
  btnHoverTextColor: '#fff',
  btnHoverBgColor: '#DE9356',
  btnBgColor: '#DE9356',
  borderRadius: '0',
  borderColor: '#DE9356',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#B1B1B1',
  selectColor: '#000000',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#fff',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#DE9356',
  bgImgColor: '',
  productTitleColor: '#030303',
  priceColor: '#DE9356',
  originalPriceColor: '#B1B1B1',
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
